/**
 * Tracks which key codes are currently held. Owns the global listeners.
 */
export class KeyboardTracker {
  private held = new Set<string>();
  private listenersAttached = false;

  attach(): void {
    if (this.listenersAttached) return;
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
    window.addEventListener("blur", this.onBlur);
    this.listenersAttached = true;
  }

  detach(): void {
    if (!this.listenersAttached) return;
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
    window.removeEventListener("blur", this.onBlur);
    this.listenersAttached = false;
    this.held.clear();
  }

  isHeld(code: string): boolean {
    return this.held.has(code);
  }

  private readonly onKeyDown = (e: KeyboardEvent): void => {
    this.held.add(e.code);
  };

  private readonly onKeyUp = (e: KeyboardEvent): void => {
    this.held.delete(e.code);
  };

  private readonly onBlur = (): void => {
    this.held.clear();
  };
}
